(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[67539,40659,81066,75847,44709,40852,81243,74453,44954,49105],{

/***/ 49105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/components/LinkWrapper/index.jsx + 2 modules
var LinkWrapper = __webpack_require__(56362);
// EXTERNAL MODULE: ./UI/components/Button/Button.module.scss
var Button_module = __webpack_require__(20195);
var Button_module_default = /*#__PURE__*/__webpack_require__.n(Button_module);
;// CONCATENATED MODULE: ./UI/components/Button/utils/useButton.js







/* harmony default export */ function useButton(_param) {
    var dark = _param.dark, secondary = _param.secondary, href = _param.href, classes = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "dark",
        "secondary",
        "href",
        "className"
    ]);
    var Component = href ? function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, (0,_object_spread/* default */.Z)({}, props));
    } : function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread/* default */.Z)({
            type: "button"
        }, props));
    };
    var _obj;
    var className = classnames_default()((Button_module_default()).button, classes, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (Button_module_default()).secondary, secondary), (0,_define_property/* default */.Z)(_obj, (Button_module_default()).dark, dark), _obj));
    return (0,_object_spread/* default */.Z)({
        Component: Component,
        className: className,
        path: href
    }, rest);
};

;// CONCATENATED MODULE: ./UI/components/Button/index.jsx






var Button = function(props) {
    var _ref = useButton(props), Component = _ref.Component, children = _ref.children, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "Component",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
Button.propTypes = {
    disabled: (prop_types_default()).bool,
    secondary: (prop_types_default()).bool,
    dark: (prop_types_default()).bool,
    onClick: (prop_types_default()).func,
    href: (prop_types_default()).string
};
/* harmony default export */ var components_Button = (Button);


/***/ }),

/***/ 67539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Header_Nav; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/Common/LinkWrapper/index.jsx + 1 modules
var LinkWrapper = __webpack_require__(40659);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./helpers/navigation.js
var navigation = __webpack_require__(48372);
// EXTERNAL MODULE: ./utils/routes.js
var routes = __webpack_require__(27727);
// EXTERNAL MODULE: ./UI/components/Svg/index.jsx
var Svg = __webpack_require__(6778);
// EXTERNAL MODULE: ./hooks/useToggle.js
var useToggle = __webpack_require__(90981);
// EXTERNAL MODULE: ./components/Common/GlobalSearch/SearchInputModal/index.jsx
var SearchInputModal = __webpack_require__(12555);
;// CONCATENATED MODULE: ./UI/sections/Header/Nav/useNav.js


var useNav = function(param) {
    var theme = param.theme, isPageScrolling = param.isPageScrolling, links = param.navLinks, isHeader = param.isHeader, setDesktopMenu = param.setDesktopMenu, isDropMenuOpened = param.isDropMenuOpened;
    var navRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isSmallDropMenuOpened = ref[0], setIsSmallDropMenuOpened = ref[1];
    var ref1 = (0,react.useState)(null), selectedSlug = ref1[0], setSlug = ref1[1];
    var ref2 = (0,react.useState)(false), hasOpenedSmallMenuInSession = ref2[0], setHasOpenedSmallMenuInSession = ref2[1];
    var ref3 = (0,react.useState)(false), disableSmallDropMenuAnimation = ref3[0], setDisableSmallDropMenuAnimation = ref3[1];
    var openDropDownMenu = function(slug) {
        if (isHeader && (0,navigation/* isHasSubNavigation */.bT)(slug)) {
            setDesktopMenu(true);
            setIsSmallDropMenuOpened(false);
        } else if (isHeader && (0,navigation/* isHasSubSmallNavigation */.wz)(slug)) {
            setDesktopMenu(false);
            setIsSmallDropMenuOpened(true);
        }
    };
    var closeDropDownMenu = (0,react.useCallback)(function() {
        setDesktopMenu(false);
    }, [
        setDesktopMenu
    ]);
    var closeSmallDropDownMenu = (0,react.useCallback)(function() {
        return setIsSmallDropMenuOpened(false);
    }, []);
    var handleOnClick = function(slug) {
        return function() {
            if (isDropMenuOpened && slug === selectedSlug) {
                setSlug(null);
                closeDropDownMenu();
            } else if (isSmallDropMenuOpened) {
                setSlug(null);
                closeSmallDropDownMenu();
            } else {
                openDropDownMenu(slug);
                setSlug(slug);
            }
        };
    };
    var toggleMenu = function(param) {
        var slug = param.slug, isOpen = param.isOpen;
        if (isOpen) {
            if (hasOpenedSmallMenuInSession) {
                setDisableSmallDropMenuAnimation(true);
            } else {
                setHasOpenedSmallMenuInSession(true);
                setDisableSmallDropMenuAnimation(false);
            }
        }
        setIsSmallDropMenuOpened(isOpen);
        setSlug(isOpen ? slug : null);
    };
    var handleNavMouseEnter = function() {
        setHasOpenedSmallMenuInSession(false);
        setDisableSmallDropMenuAnimation(false);
    };
    var handleNavMouseLeave = function() {
        setHasOpenedSmallMenuInSession(false);
        setDisableSmallDropMenuAnimation(false);
    };
    (0,react.useEffect)(function() {
        var handleClickOutside = function(param) {
            var target = param.target;
            var current = (navRef || {}).current;
            if ((isDropMenuOpened || isSmallDropMenuOpened) && current && !current.contains(target)) {
                closeDropDownMenu();
                closeSmallDropDownMenu();
                setSlug(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            return document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        closeDropDownMenu,
        isDropMenuOpened,
        isSmallDropMenuOpened,
        setSlug,
        closeSmallDropDownMenu
    ]);
    return {
        navRef: navRef,
        theme: theme,
        isPageScrolling: isPageScrolling,
        links: links,
        isHeader: isHeader,
        handleOnClick: handleOnClick,
        isSmallDropMenuOpened: isSmallDropMenuOpened,
        isDropMenuOpened: isDropMenuOpened,
        closeDropDownMenu: closeDropDownMenu,
        closeSmallDropDownMenu: closeSmallDropDownMenu,
        selectedSlug: selectedSlug,
        toggleMenu: toggleMenu,
        disableSmallDropMenuAnimation: disableSmallDropMenuAnimation,
        handleNavMouseEnter: handleNavMouseEnter,
        handleNavMouseLeave: handleNavMouseLeave
    };
};

// EXTERNAL MODULE: ./UI/sections/Header/Nav/styles.module.scss
var styles_module = __webpack_require__(54148);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/sections/Header/Nav/index.jsx
















var SmallDropDownMenu = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(18201)]).then(__webpack_require__.bind(__webpack_require__, 18201));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18201)
            ];
        }
    }
});
var Nav = function(props) {
    var ref = useNav(props), theme = ref.theme, navRef = ref.navRef, isPageScrolling = ref.isPageScrolling, links = ref.links, isHeader = ref.isHeader, handleOnClick = ref.handleOnClick, isSmallDropMenuOpened = ref.isSmallDropMenuOpened, closeSmallDropDownMenu = ref.closeSmallDropDownMenu, selectedSlug = ref.selectedSlug, toggleMenu = ref.toggleMenu, disableSmallDropMenuAnimation = ref.disableSmallDropMenuAnimation, handleNavMouseEnter = ref.handleNavMouseEnter, handleNavMouseLeave = ref.handleNavMouseLeave;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isFullscreenSearch = ref1[0], toggleFullscreenSearch = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: classnames_default()((styles_module_default()).desktopMenu, (0,_define_property/* default */.Z)({}, (styles_module_default()).pageScrolled, isPageScrolling)),
                ref: navRef,
                onMouseEnter: handleNavMouseEnter,
                onMouseLeave: handleNavMouseLeave,
                children: links === null || links === void 0 ? void 0 : links.map(function(param) {
                    var title = param.title, path = param.path, dynamicPath = param.dynamicPath, slug = param.slug;
                    var itemContent = /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (styles_module_default()).underline,
                        children: title
                    });
                    return (path || isHeader) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: classnames_default()((styles_module_default())[theme], (0,_define_property/* default */.Z)({}, (styles_module_default()).nonClickableItem, !path)),
                        onClick: handleOnClick(path),
                        onMouseEnter: function() {
                            return toggleMenu({
                                slug: slug,
                                isOpen: true
                            });
                        },
                        onMouseLeave: function() {
                            return toggleMenu({
                                slug: slug,
                                isOpen: false
                            });
                        },
                        children: [
                            path ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                                isLocalLink: true,
                                path: path,
                                dynamicRouting: dynamicPath,
                                children: itemContent
                            }) : itemContent,
                            (0,navigation/* isHasSubSmallNavigation */.wz)(slug) && isHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallDropDownMenu, {
                                slug: slug,
                                selected: selectedSlug,
                                isDropMenuOpened: isSmallDropMenuOpened,
                                isPageScrolledDown: isPageScrolling,
                                closeDropDownMenu: closeSmallDropDownMenu,
                                theme: theme,
                                disableAnimation: disableSmallDropMenuAnimation
                            })
                        ]
                    }, "menuItem/".concat(title));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((styles_module_default()).contactUsContainer, (0,_define_property/* default */.Z)({}, (styles_module_default()).pageScrolled, isPageScrolling)),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                        type: constants/* SVG_IMAGES_TYPES.searchLg */.NL.searchLg,
                        handleOnClick: toggleFullscreenSearch,
                        className: classnames_default()((styles_module_default())[theme], (styles_module_default()).searchIcon)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: classnames_default()((styles_module_default())[theme], (styles_module_default()).contactUs),
                        onClick: handleOnClick(routes/* routes.contact.slug */._.contact.slug),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                            isLocalLink: true,
                            path: routes/* routes.contact.path */._.contact.path,
                            dynamicRouting: routes/* routes.contact.dynamicPath */._.contact.dynamicPath,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (styles_module_default()).underline,
                                children: routes/* routes.contact.title */._.contact.title
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInputModal/* default */.Z, {
                isFullscreenSearch: isFullscreenSearch,
                closeFullscreenSearch: toggleFullscreenSearch
            })
        ]
    });
};
Nav.defaultProps = {
    theme: "dark",
    navLinks: constants/* NAV_LINKS */.qy,
    isHeader: false
};
Nav.propTypes = {
    isPageScrolling: (prop_types_default()).bool.isRequired,
    theme: (prop_types_default()).string,
    navLinks: prop_types_default().instanceOf(Array),
    isHeader: (prop_types_default()).bool
};
/* harmony default export */ var Header_Nav = (/*#__PURE__*/(0,react.memo)(Nav));


/***/ }),

/***/ 67891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var UI_components_Svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6778);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96076);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49887);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);







var SearchInput = function(param) {
    var inputRef = param.inputRef, inputValue = param.inputValue, setInputValue = param.setInputValue, onClose = param.onClose, _withClear = param.withClear, withClear = _withClear === void 0 ? false : _withClear;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var handleSearch = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (!inputValue.trim()) return;
        router.push("/search/".concat(encodeURIComponent(inputValue)));
        if (onClose) {
            onClose();
            setInputValue("");
        }
    }, [
        inputValue
    ]);
    var handleOnChangeInput = function(param) {
        var value = param.target.value;
        setInputValue(value);
    };
    var handleClearValue = function() {
        setInputValue("");
    };
    var handleOnCloseModalWindow = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (onClose) {
            onClose();
            setInputValue("");
        }
    }, [
        onClose,
        setInputValue
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleOnKeyDown = function(param) {
            var key = param.key;
            if (key === "Escape") {
                handleOnCloseModalWindow();
            }
            if (key === "Enter") {
                handleSearch();
            }
        };
        document.addEventListener("keydown", handleOnKeyDown);
        return function() {
            return document.removeEventListener("keydown", handleOnKeyDown);
        };
    }, [
        handleOnCloseModalWindow,
        handleSearch
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().inputContainer),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Svg__WEBPACK_IMPORTED_MODULE_4__["default"], {
                type: utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .SVG_IMAGES_TYPES.searchLg */ .NL.searchLg,
                handleOnClick: handleSearch,
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().searchIcon)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                ref: inputRef,
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().input),
                type: "text",
                placeholder: "Find all you need (e.g. services, blog, news, contact info)",
                onChange: handleOnChangeInput,
                value: inputValue
            }),
            withClear && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Svg__WEBPACK_IMPORTED_MODULE_4__["default"], {
                type: utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .SVG_IMAGES_TYPES.closeSvg */ .NL.closeSvg,
                handleOnClick: handleClearValue,
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().searchIcon)
            })
        ]
    });
};
SearchInput.defaultProps = {
    isFullscreenSearch: false
};
SearchInput.propTypes = {
    isFullscreenSearch: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool),
    closeFullscreenSearch: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func.isRequired)
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(SearchInput));


/***/ }),

/***/ 12555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var UI_components_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49105);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16744);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _SearchInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67891);








var SearchInputModal = function(param) {
    var isFullscreenSearch = param.isFullscreenSearch, closeFullscreenSearch = param.closeFullscreenSearch;
    var inputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), inputValue = ref[0], setInputValue = ref[1];
    var handleOnCloseModalWindow = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        closeFullscreenSearch();
        setInputValue("");
    }, [
        closeFullscreenSearch
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isFullscreenSearch && inputRef && inputRef.current) {
            inputRef.current.focus();
        }
    }, [
        isFullscreenSearch
    ]);
    var modalRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var handleOnClick = function(param) {
        var target = param.target;
        if (modalRef && modalRef.current) {
            if (modalRef.current.isEqualNode(target)) handleOnCloseModalWindow();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().modalWindowContainer), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().show), isFullscreenSearch)),
        onClick: handleOnClick,
        ref: modalRef,
        role: "dialog",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().modalWindow),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SearchInput__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    inputRef: inputRef,
                    inputValue: inputValue,
                    setInputValue: setInputValue,
                    onClose: handleOnCloseModalWindow
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Button__WEBPACK_IMPORTED_MODULE_6__["default"], {
                    onClick: handleOnCloseModalWindow,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().cancelButton),
                    children: "Cancel"
                })
            ]
        })
    });
};
SearchInputModal.defaultProps = {
    isFullscreenSearch: false
};
SearchInputModal.propTypes = {
    isFullscreenSearch: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    closeFullscreenSearch: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().func.isRequired)
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(SearchInputModal));


/***/ }),

/***/ 40659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Common_LinkWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./utils/ga.js
var ga = __webpack_require__(48114);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/helpers/index.js
var isAbsoluteUrl = function(path) {
    try {
        var _ = new URL(path);
        return true;
    } catch (e) {
        return false;
    }
};

// EXTERNAL MODULE: ./components/Common/LinkWrapper/styles.module.scss
var styles_module = __webpack_require__(81098);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/index.jsx










var LinkWrapper = function(param) {
    var path = param.path, className = param.className, children = param.children, googleAnalyticProps = param.googleAnalyticProps, isSocialLink = param.isSocialLink, onClick = param.onClick;
    var isAbsoluteLink = (0,react.useMemo)(function() {
        return isAbsoluteUrl(path);
    }, [
        path
    ]);
    var isLocalLink = !isAbsoluteLink || path.includes(constants/* CUSTOM_DOMAIN */.zq);
    if (!path) {
        return children;
    }
    var target = !isLocalLink ? "_blank" : undefined;
    var rel = isSocialLink || isLocalLink ? undefined : "noopener noreferrer nofollow";
    var href = !isAbsoluteLink && path[0] !== "/" ? "/".concat(path) : path;
    var handleOnClick = function(e) {
        if (!isEmpty_default()(googleAnalyticProps)) {
            var category = googleAnalyticProps.category, action = googleAnalyticProps.action, label = googleAnalyticProps.label, data = googleAnalyticProps.data;
            ga/* default.trackEvent */.Z.trackEvent(category || data, action || data, label || data);
        }
        onClick(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        /* TODO: if you need to instantly open pages via links in the navigation,
      you can remove this code to enable link page generation and loading. However, performance will be degraded
      more: https://nextjs.org/docs/api-reference/next/link */ prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: classnames_default()((styles_module_default()).link, className),
            onClick: handleOnClick,
            target: target,
            rel: rel,
            children: children
        })
    });
};
LinkWrapper.defaultProps = {
    path: null,
    className: null,
    googleAnalyticProps: {},
    children: null,
    isSocialLink: false,
    onClick: function() {}
};
LinkWrapper.propTypes = {
    path: (prop_types_default()).string,
    className: (prop_types_default()).string,
    googleAnalyticProps: prop_types_default().instanceOf(Object),
    children: (prop_types_default()).node,
    isSocialLink: (prop_types_default()).bool,
    onClick: (prop_types_default()).func
};
/* harmony default export */ var Common_LinkWrapper = (LinkWrapper);


/***/ }),

/***/ 48372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bT": function() { return /* binding */ isHasSubNavigation; },
/* harmony export */   "rb": function() { return /* binding */ isHasSubSmallNavigationMobile; },
/* harmony export */   "wz": function() { return /* binding */ isHasSubSmallNavigation; }
/* harmony export */ });
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96076);

var isHasSubNavigation = function(slug) {
    return utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .LINKS_WITH_SUB_NAVIGATION.includes */ .Rv.includes(slug);
};
var isHasSubSmallNavigation = function(slug) {
    return Object.keys(utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .INTERACTIVE_LINKS */ .RG).includes(slug);
};
var isHasSubSmallNavigationMobile = function(slug) {
    return Object.keys(utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .INTERACTIVE_LINKS_MOBILE */ .bP).includes(slug);
};


/***/ }),

/***/ 90981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var reducer = function(stateHandler) {
    return function(state) {
        if (typeof stateHandler === "function") {
            stateHandler(!state);
        }
        return !state;
    };
};
function useToggle(initialState, stateHandler) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(reducer(stateHandler), !!initialState), isEnabled = ref[0], toggle = ref[1];
    return [
        isEnabled,
        toggle
    ];
}
/* harmony default export */ __webpack_exports__["Z"] = (useToggle);


/***/ }),

/***/ 20195:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__uIelC","secondary":"Button_secondary__2AQtd","dark":"Button_dark__n_Cmy"};

/***/ }),

/***/ 54148:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"desktopMenu":"styles_desktopMenu___4Zcj","underline":"styles_underline__YNKTC","dark":"styles_dark__X8DHg","light":"styles_light__CtWfV","pageScrolled":"styles_pageScrolled__6y7X4","contactUs":"styles_contactUs__Cc8hw","contactUsContainer":"styles_contactUsContainer__D2S1v","searchIcon":"styles_searchIcon__4wdRq"};

/***/ }),

/***/ 49887:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"styles_inputContainer__sSEFN"};

/***/ }),

/***/ 16744:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalWindowContainer":"styles_modalWindowContainer__FTnFT","modalWindow":"styles_modalWindow__rd1WZ","show":"styles_show__FUbDq","cancelButton":"styles_cancelButton__dVb8a"};

/***/ }),

/***/ 81098:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__MXUD5"};

/***/ })

}]);